// extracted by mini-css-extract-plugin
export var anchor = "index-module--anchor--U9-GH";
export var anchorWrapper = "index-module--anchor-wrapper--7Zje8";
export var list = "index-module--list--C-84m";
export var listItem = "index-module--list-item--UYnU1";